
import { defineComponent, onMounted, watch } from 'vue';
import { useField } from 'vee-validate';
import AppFormItem from '@/components/UI/AppFormItem.vue';

export default defineComponent({
  inheritAttrs: false,
  components: { AppFormItem },
  emits: ['on-enter'],
  props: {
    modelValue: { type: String },
    name: { type: String, required: true },
    label: { type: String, required: true },
    controlClass: { type: String, default: '' },
    propError: { type: String, default: '' },
    type: { type: String, default: 'text' },
    inputmode: { type: String, default: 'text' },
    enterkeyhint: { type: String, default: 'enter' },
  },
  setup(props, { emit }) {
    const { value, errorMessage } = useField(props.name);

    function onEnter(input) {
      emit('on-enter', input);
    }

    watch(() => props.modelValue, (newValue) => {
      value.value = props.modelValue;
    });

    onMounted(() => {
      if (props.modelValue) {
        value.value = props.modelValue;
      }
    });

    return { value, errorMessage, onEnter };
  },
});
